import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-edit\"><path d=\"M7 5.6 5.4 4l-4 4v1.6H3l4-4zm.8-.8 1.7-1.7-1.6-1.6-1.7 1.7 1.6 1.6zM8.2.4l2.3 2.3c.2.2.2.5 0 .8l-7 7c-.1.1-.2.2-.4.2H.8c-.3 0-.5-.2-.5-.5V7.8c0-.1.1-.3.2-.4l7-7c.2-.2.5-.2.7 0z\" style=\"fill-rule:evenodd;clip-rule:evenodd\" transform=\"translate(.5 .5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol